import { Icon, IconButton } from '@lounge-fe/ui-kit'
import { useCarouselContext } from '@lounge-fe/ui-kit/src/components/Carousel/Carousel'
import { IconButtonProps } from '@lounge-fe/ui-kit/src/components/IconButton/types'
import classNames from 'classnames'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

const Arrow = ({ className, onClick, icon }: IconButtonProps) => (
  <IconButton
    icon={icon}
    aria-label="Previous slide"
    variant="ghost"
    className={classNames(
      className,
      '!bg-white shadow-3 absolute z-10 top-1/2',
    )}
    onClick={onClick}
    size="sm"
  />
)

export const ArrowLeft = () => {
  const { t } = useTranslation()
  const { canScrollPrev, embla } = useCarouselContext()
  const onClick = useCallback(() => embla?.scrollPrev(), [embla])

  if (!canScrollPrev) {
    return null
  }
  return (
    <Arrow
      icon={<Icon.ChevronLeft className="w-[6px] !text-base-primary" />}
      className="left-0 -translate-x-1/2"
      onClick={onClick}
      aria-label={t('action.back')}
    />
  )
}

export const ArrowRight = () => {
  const { t } = useTranslation()
  const { canScrollNext, embla } = useCarouselContext()
  const onClick = useCallback(() => embla?.scrollNext(), [embla])

  if (!canScrollNext) {
    return null
  }

  return (
    <Arrow
      icon={<Icon.ChevronRight className="w-[6px] !text-base-primary" />}
      className="right-0 translate-x-1/2"
      onClick={onClick}
      aria-label={t('action.next')}
    />
  )
}
